import React from "react";
import { Modal }  from "react-bootstrap";

export default class AskToUseSafariOniOS extends React.Component {
  render () {
    const { show, onHide } = this.props;
    return (
      <Modal show={show}>
        <Modal.Body>
          <h4>
          Please use Safari on an Apple device. Other browsers may not work because Apple limits their functionality.
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button 
              className="btn btn-primary"
              onClick={onHide}
            >
              ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}